/** Maps ISO 639-1 language codes to their representative country flag emoji. */
const LANGUAGE_FLAGS: Record<string, string> = {
  en: '🇺🇸',
  fr: '🇫🇷',
  es: '🇪🇸',
  de: '🇩🇪',
  it: '🇮🇹',
  pt: '🇧🇷',
  nl: '🇳🇱',
  zh: '🇨🇳',
  ja: '🇯🇵',
  ko: '🇰🇷',
  ar: '🇸🇦',
  ru: '🇷🇺',
  no: '🇳🇴',
};

/** Returns the flag emoji for a given language code, or an empty string if unknown. */
export function getLanguageFlag(lang: string): string {
  return LANGUAGE_FLAGS[lang?.toLowerCase()] ?? '';
}
